import {
  PaymentSortOption,
  enumPaymentSortOption,
} from '@rematter/frontend-lib-api-client';
import { atom } from 'jotai';

import { paymentsQueryAtom } from '../_graphql/queryFinancePayments';

// 🔘🔘🔘 PLAIN ATOMS
export const $limit = atom(25);
export const $offset = atom(0);
export const $sorting = atom<PaymentSortOption[]>([
  enumPaymentSortOption.DateDesc,
]);

// 🟢🟢🟢 REMOTE DATA
export const createFinancialAccountPaymentsAtom = (accountId?: string) =>
  paymentsQueryAtom((get) => {
    const limit = get($limit);
    const offset = get($offset);
    const sorting = get($sorting);

    return {
      skip: !accountId,
      variables: {
        financialAccountIDs: accountId ? [accountId] : undefined,
        limit,
        offset,
        sorting,
      },
    };
  });
